import styled from 'styled-components'
import theme from 'theme_'

export const JobDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const JobDetailsBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  @media ${theme.devices.tablet} {
    flex-direction: row;
  }
`
